import { CatalogItem } from '../../../../../redux/api/fymAPI.types';
import { catalogArtworkSrc } from '../../../../smartLinks/catalog/catalogArtwork';

/**
 * The artwork a release shows (the upload when there is one, else the snapshot), sized for the
 * place where it is drawn: `cssPx` CSS pixels. It goes through imgproxy (owner rule 2026-10-19;
 * QA 2026-10-28, mob-7: the Studio drew a 3024 px original for a 44 px thumbnail). For the
 * original file (a size check), use `catalogArtworkOriginalSrc`.
 */
export function releaseArtworkUrl(item: CatalogItem, cssPx: number): string | undefined {
  return catalogArtworkSrc(item, cssPx);
}

/** The sizes of the places that draw the release artwork. */
export const RELEASE_ARTWORK_PX = {
  /** A song row and the mini still of the theme chip. */
  thumb: 64,
  /** The song picker hero card. */
  hero: 360,
  /** A theme still or an asset preview of the Studio and the Theme panel. */
  preview: 640,
} as const;

/**
 * The share of the screen width that the biggest Studio preview takes on a phone. The previews on
 * a 375 px phone are 234 px and smaller (QA 2026-10-28, mob-7: they loaded 1536 px images).
 */
const PHONE_PREVIEW_SHARE = 0.62;

/**
 * The CSS size of the preview artwork for a screen `viewportWidth` px wide: the desktop preview
 * size, or the size of the biggest preview on a smaller screen. Pure.
 */
export function previewArtworkPx(viewportWidth: number): number {
  if (!Number.isFinite(viewportWidth) || viewportWidth <= 0) {
    return RELEASE_ARTWORK_PX.preview;
  }
  return Math.min(
    RELEASE_ARTWORK_PX.preview,
    Math.max(RELEASE_ARTWORK_PX.thumb, Math.round(viewportWidth * PHONE_PREVIEW_SHARE))
  );
}

/** `previewArtworkPx` of this window (read once: one URL for every preview of the page). */
export function windowPreviewArtworkPx(): number {
  return typeof window === 'undefined' ? RELEASE_ARTWORK_PX.preview : previewArtworkPx(window.innerWidth);
}
